import { render, staticRenderFns } from "./CatalogDocumentTable.vue?vue&type=template&id=ec86a298&scoped=true&"
import script from "./CatalogDocumentTable.vue?vue&type=script&lang=js&"
export * from "./CatalogDocumentTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec86a298",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/vagrant/interfaces/online/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VTooltip } from 'vuetify/lib'
installComponents(component, {VDataTable,VIcon,VTooltip})
